// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets-public-results/" + chunkId + "." + {"79":"0f6c088bf78c34edd9b4","309":"fe69471fe0a7a6f7f8b8","448":"1a3d44d942fdc4479d6f","651":"8008b13322cd13679df0","893":"69d82eaac5028ed76eb8","949":"73843c471ea39deda242"}[chunkId] + ".chunk.js";
};